import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { Session } from '@supabase/supabase-js'
import { AppState } from '..'
import { createSelector } from 'reselect'
export interface IUserProfileState {
  displayName: string | null
  avatarUrl: string | null
}

const initialState: IUserProfileState = {
  displayName: null,
  avatarUrl: null
}

const userProfileSlice = createSlice({
  name: 'userProfile',
  initialState,
  reducers: {
    setDisplayName: (state, action: PayloadAction<string | null>) => {
      state.displayName = action.payload
    },
    setAvatarUrl: (state, action: PayloadAction<string | null>) => {
      state.avatarUrl = action.payload
    },
    clearUserProfile: () => {
      return initialState
    }
  }
})

const getDisplayname = (state: AppState) => state.userProfile.displayName
const getAvatarUrl = (state: AppState) => state.userProfile.avatarUrl

export const userProfileSelector = createSelector(
  [getDisplayname, getAvatarUrl],
  (displayname, avatarUrl) => ({ displayname, avatarUrl })
)

export const { setDisplayName, setAvatarUrl, clearUserProfile } =
  userProfileSlice.actions
export default userProfileSlice.reducer
